import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import videojs from 'video.js';

import * as api from '../../../constants/api';

import * as headerActionCreators from '../../../actions/header';
import * as videosActionCreators from '../../../actions/videos';
let allActionCreators = Object.assign({}, headerActionCreators, videosActionCreators);


class VideoPlayer extends React.Component {

	static propTypes = {
    location: PropTypes.object,
    video: PropTypes.object,
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {
			videoOptions: {
				autoplay: true,
				controls: true,
				loop: false,
			  fluid: true,
			},
			playerWidth: '100%',
			playerHeight: '100%',
			playerMargin: '0 auto',
			loadingVideo: true,
			startTime: null,
			finishTime: null,
		}

		this.finishBuffer = 10;

		// Bind event listeners
    this.adjustPlayerSize = ::this.adjustPlayerSize;
	}

	componentWillMount() {
		if(this.props.videos.currentVideo) {
  		this.props.headerTitle(this.props.videos.currentVideo.name);
  	}
  	window.addEventListener('resize', this.adjustPlayerSize, false);
  	this.props.headerBack(true);
  }

  completeVideo() {
  	if(this.state.finishTime === null) {
  		console.log('complete!');
  		this.setState({
  			finishTime: Date.now(),
  		}, () => {
  			let completeData = {
  				"video_id": this.props.videos.currentVideo.id,
  				"start_time": this.state.startTime,
  				"end_time": this.state.finishTime,
  			}
  			this.props.videosComplete(completeData);
  		})
  	}
  }

	componentDidMount() {

    this.adjustPlayerSize();

		// If navigated directly, route to dashboard
		if(!this.props.videos.currentVideo) {
			this.context.router.push('/');
		}

		const videoParams = Object.assign({}, this.state.videoOptions, {
			sources: [{
				src: api.STREAMING_URL + '/' + this.props.videos.currentVideo.videoId,
				type: 'video/mp4'
			}]
		});

		this.videoNode.onplay = () => {
			this.setState({
				loadingVideo: false
			}, () => {
				// console.log('playing');
				this.setState({
					startTime: Date.now(),
				});
			});
		};

		this.player = videojs(this.videoNode, videoParams, function onPlayerReady() {
      // console.log('onPlayerReady', this)
    });

		this.player.on('timeupdate', () => {
			// console.log('Time: ' + this.player.currentTime());

			if((this.props.videos.currentVideo.videoLength - this.player.currentTime()) < this.finishBuffer) {
				this.completeVideo();
			}
		});

    this.player.on('ended', () => {
			this.completeVideo();
		});

    this._backdrop.addEventListener('contextmenu', event => event.preventDefault());
  }

  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }
    window.removeEventListener('resize', this.adjustPlayerSize, false);
    this._backdrop.removeEventListener('contextmenu', event => event.preventDefault(), false);
  }

  adjustPlayerSize() {
  	if((this._backdrop.offsetWidth / this._backdrop.offsetHeight) > (16/9)) {
  		// Height = 100%, width < 100%; margin 0 auto;
  		this.setState({
  			playerWidth: Math.round(this._backdrop.offsetHeight * (16/9)) + 'px',
				playerHeight: this._backdrop.offsetHeight + 'px',
				playerMargin: '0 auto',
  		});
  	} else {
  		// Height < 100%, width = 100%; margin (backdropHeight*(1 - 9/16))/2 0;
  		this.setState({
  			playerWidth: this._backdrop.offsetWidth + 'px',
				playerHeight: Math.round(this._backdrop.offsetWidth * (9/16)) + 'px',
				playerMargin: Math.round((this._backdrop.offsetHeight - this._backdrop.offsetWidth*(9/16)) / 2) + 'px 0',
  		});
  	}
  }

  dashboardNav() {
		this.props.videosSetCurrent(null);
		this.context.router.push('/');
  }

	render() {
		return (
			<div className='VideoPlayer'>
				<div className='closePlayer' onClick={::this.dashboardNav}>
          <div className='closeX'>&times;</div>
        </div>
				<div className='playerBackdrop' ref={(c) => this._backdrop = c}>
					<div 
						className='playerHolder'
						style={{
							width: this.state.playerWidth,
							height: this.state.playerHeight,
							margin: this.state.playerMargin,
						}}>
						<div data-vjs-player>
			        <video ref={ node => this.videoNode = node } className="video-js"></video>
			      </div>
		      </div>
				</div>
				{this.state.loadingVideo ?
					<div className='loadingVideo'>
						<div className='loadingImgWrapper'>
							<img src='/img/loadw.gif' />
						</div>
					</div>
					: null
				}
			</div>
		);
	}
}
export default VideoPlayer;

function mapStateToProps(state) {
  return {
    common: state.common,
    header: state.header,
    videos: state.videos,
  };
}

export const VideoPlayerContainer = connect(
  mapStateToProps,
  allActionCreators
)(VideoPlayer);




// WEBPACK FOOTER //
// ./src/components/views/videos/VideoPlayer.jsx